import { styled, useTheme } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import {
  getResolutionAutomatedLabel,
  getResolutionTierLabel,
  NA,
} from '../constants';
import { RESOLUTION_CHART_COLORS } from 'src/components/dashboard-pages/solve-insights/common/resolutionChartColors';

const getBadgeBackground = (resolutionTier?: string | null) => {
  if (
    resolutionTier === 'non_automated' ||
    resolutionTier === 'assisted' ||
    resolutionTier === 'pending'
  ) {
    return 'grey';
  }

  if (resolutionTier === 'verified') {
    return 'green';
  }

  return 'contained';
};

export const ResolutionTierBadge = ({
  resolutionTier,
}: {
  resolutionTier?: string | null;
}) => {
  const { palette } = useTheme();
  const label = getResolutionTierLabel(resolutionTier);

  if (!resolutionTier || resolutionTier === 'unknown_resolution_tier') {
    return (
      <Typography color={palette.colors.grey[500]} variant='font14'>
        {label}
      </Typography>
    );
  }

  return (
    <Badge $backgroundColor={getBadgeBackground(resolutionTier)}>{label}</Badge>
  );
};

export const ResolutionAutomatedLabel = ({
  resolutionAutomated,
}: {
  resolutionAutomated?: boolean | null;
}) => {
  const { palette } = useTheme();
  const label = getResolutionAutomatedLabel(resolutionAutomated);

  return (
    <Typography
      color={
        label === NA ? palette.colors.grey[500] : palette.colors.slate[900]
      }
      variant='font14'
    >
      {label}
    </Typography>
  );
};

const Badge = styled('span')<{
  $backgroundColor: ReturnType<typeof getBadgeBackground>;
}>`
  background-color: ${({ $backgroundColor, theme }) => {
    if ($backgroundColor === 'green') {
      return theme.palette.colors.green[700];
    }
    if ($backgroundColor === 'grey') {
      return RESOLUTION_CHART_COLORS.nonAutomated;
    }
    return RESOLUTION_CHART_COLORS.contained;
  }};
  border-radius: 4px;
  color: ${({ theme }) => theme.palette.colors.white};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  padding: 2px 6px;
  white-space: nowrap;
`;
